import React, { useEffect } from 'react';
import { i18n } from '@lingui/core';
import { I18nProvider as I18nProvider$1 } from '@lingui/react';
import { useNavBarContext } from '../NavBarProvider/NavBarContext.es.js';
import { i18nCatalogs } from '../../utils/i18n.es.js';
import { DefaultLanguage } from '../../enums/languages.es.js';

i18n.load(i18nCatalogs);
i18n.activate(DefaultLanguage);
var I18nProvider = function I18nProvider(_ref) {
  var children = _ref.children;
  var _useNavBarContext = useNavBarContext(),
    language = _useNavBarContext.language;
  useEffect(function () {
    if (i18n.locale !== language) {
      i18n.activate(language);
    }
  }, [language]);
  return /*#__PURE__*/React.createElement(I18nProvider$1, {
    i18n: i18n
  }, children);
};

export { I18nProvider };
